"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function InternalServerErrorFromJSON(json) {
    return InternalServerErrorFromJSONTyped(json, false);
}
exports.InternalServerErrorFromJSON = InternalServerErrorFromJSON;
function InternalServerErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
    };
}
exports.InternalServerErrorFromJSONTyped = InternalServerErrorFromJSONTyped;
function InternalServerErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
    };
}
exports.InternalServerErrorToJSON = InternalServerErrorToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZXJuYWxTZXJ2ZXJFcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9nZW5lcmF0ZWQvY2xpZW50L21vZGVscy9JbnRlcm5hbFNlcnZlckVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxvQkFBb0I7QUFDcEIsb0JBQW9CO0FBQ3BCOzs7Ozs7Ozs7O0dBVUc7O0FBRUgsd0NBQStDO0FBcUIvQyxTQUFnQiwyQkFBMkIsQ0FBQyxJQUFTO0lBQ2pELE9BQU8sZ0NBQWdDLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ3pELENBQUM7QUFGRCxrRUFFQztBQUVELFNBQWdCLGdDQUFnQyxDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDcEYsSUFBSSxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsRUFBRTtRQUN6QyxPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILE1BQU0sRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUM7UUFDeEQsU0FBUyxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQztLQUNwRSxDQUFDO0FBQ04sQ0FBQztBQVRELDRFQVNDO0FBRUQsU0FBZ0IseUJBQXlCLENBQUMsS0FBa0M7SUFDeEUsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3JCLE9BQU8sU0FBUyxDQUFDO0tBQ3BCO0lBQ0QsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ2hCLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsTUFBTSxFQUFFLEtBQUssQ0FBQyxJQUFJO1FBQ2xCLFNBQVMsRUFBRSxLQUFLLENBQUMsT0FBTztLQUMzQixDQUFDO0FBQ04sQ0FBQztBQVpELDhEQVlDIn0=